import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { GrupoListarComponent } from './grupo-listar.component';
import { GrupoListarRoutingModule } from './grupo-listar-routing.module';
import { HttpClientModule } from '@angular/common/http';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from "primeng/tooltip";
import { DividerModule } from 'primeng/divider';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { MessagesModule } from 'primeng/messages';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';


@NgModule({
 
  imports: [
    CommonModule,
    FormsModule,    
    TableModule,
    HttpClientModule,
    GrupoListarRoutingModule,
    ButtonModule,
    InputTextModule,
    TooltipModule,
    DividerModule,
    ProgressSpinnerModule,
    ConfirmDialogModule,
    MessagesModule,
    DropdownModule
  ],
  providers: [
    ConfirmationService
  ],
  declarations: [
    GrupoListarComponent
  ]
})
export class GrupoListarModule { }
